import { render, staticRenderFns } from "./colHeight-editor.vue?vue&type=template&id=afe2e18a&scoped=true&"
import script from "./colHeight-editor.vue?vue&type=script&lang=js&"
export * from "./colHeight-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe2e18a",
  null
  
)

export default component.exports